import React from "react"
import { Flex, Box } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import StoryCard from "./story-card"
import Section from "../../section/section"

const Stories = ({ data }) => {
  const { heading, headingMaxWidths, stories } = data
  const isSingleStory = stories.length === 1

  return (
    <Section>
      <Box mb={[32, null, 40, 80]} width={headingMaxWidths} mx="auto">
        <TextElementNova
          text={heading}
          element="h2"
          className="Title-20-Super-Normal text-center"
        />
      </Box>
      <Flex flexWrap="wrap">
        {stories?.map((item, index) => (
          <Box key={index} width={isSingleStory ? 1 : [1, null, null, 0.5]}>
            <StoryCard
              data={item}
              index={index}
              isSingleStory={isSingleStory}
            />
          </Box>
        ))}
      </Flex>
    </Section>
  )
}

export default Stories
